import get from "lodash.get";
import fetchJsonLd from "./fetchJsonLd.js";
export default (resourceUrl, options = {}) => {
    return fetchJsonLd(resourceUrl, Object.assign({ itemsPerPage: 0 }, options)).then((d) => ({
        parameters: get(d, "body.hydra:search.hydra:mapping"),
    }));
};
//# sourceMappingURL=fetchResource.js.map